import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
export function ScrollProgress() {
    const [progress, setProgress] = useState(0);
    useEffect(() => {
        const onScroll = () => {
            const total = document.documentElement.scrollHeight - window.innerHeight;
            setProgress(total > 0 ? (window.scrollY / total) * 100 : 0);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    return (_jsx("div", { className: "fixed top-0 left-0 h-[2px] bg-text-primary z-50", style: { width: `${progress}%` }, role: "progressbar", "aria-valuenow": Math.round(progress), "aria-valuemin": 0, "aria-valuemax": 100 }));
}
//# sourceMappingURL=ScrollProgress.js.map